import { IRootState } from '../../../store'
import { IVentricularAssistTypeOptions } from '../store/options.types'

export const getVentricularAssistDeviceOptionsSelector = (state: IRootState): IVentricularAssistTypeOptions =>
  state.options.ventricularAssistTypeOptions
